var React = require('react');

function SendBackward (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M464,160H208a48,48,0,0,0-48,48V464a48,48,0,0,0,48,48H464a48,48,0,0,0,48-48h0V208A48,48,0,0,0,464,160ZM448,448H224V224H448Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M160,352H48A48,48,0,0,1,0,304V48A48,48,0,0,1,48,0H304a48,48,0,0,1,48,48V160H208a48,48,0,0,0-48,48Z","className":"fa-primary","key":2})]);
}

SendBackward.defaultProps = {"viewBox":"0 0 514 512","className":"icon"};

module.exports = SendBackward;

SendBackward.default = SendBackward;
